import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import Heading from 'components/Heading';
import Button from 'components/Button';

import {
  SampleBannerWrapper,
  HeaderRowWrapper,
  ButtonsWrapper,
  CloseButtonWrapper,
} from 'apps/share/blocks/SampleBanner.styles';

const SampleBanner = props => {
  const { filesList } = props;
  if (!Array.isArray(filesList) && filesList?.length === 0) return null;

  const filesListOutput = filesList.map((obj, index) => (
    <a key={index} href={obj?.path} download={obj?.name}>
      <Button variant='primary' size='small' margin='small' text={obj?.label} />
    </a>
  ));

  return (
    <SampleBannerWrapper>
      <CloseButtonWrapper>
        <Button
          outline
          variant='minimal'
          icon='close'
          size='xsmall'
          onClick={props.onClose}
        />
      </CloseButtonWrapper>
      <HeaderRowWrapper>
        <Heading level='5' size='small'>
          <Trans>No file at hand to try out CAD Rooms?</Trans>
        </Heading>
        <Heading level='5' size='small' weight='regular' margin='0 0 0 small'>
          <Trans>Try one of these...</Trans>
        </Heading>
      </HeaderRowWrapper>
      <ButtonsWrapper>{filesListOutput}</ButtonsWrapper>
    </SampleBannerWrapper>
  );
};

SampleBanner.defaultProps = {
  filesList: [
    {
      label: 'CNC Mill by +Mekanika',
      name: 'cnc_router(mekanika).step',
      path: 'https://wikifactory.com/files/RmlsZTozMjQyMjg=',
    },
    {
      label: 'Drone Frame by +Dronecoria',
      name: 'dronecoria_frame(dronecoria).3dm',
      path: 'https://wikifactory.com/files/RmlsZTo1NTU2NDY=',
    },
    {
      label: 'Plastic Shredder by @josephaklatt',
      name: 'plastic_shredder(josephaklatt).SLDASM',
      path: 'https://wikifactory.com/files/RmlsZTo2MzEwMTI=',
    },
  ],
};

SampleBanner.propTypes = {
  filesList: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func,
};

export default withNamespaces()(SampleBanner);
